import { FiltersTypes } from "../../../../common/types/filters/general";
import { Counterparty } from "../../../../common/types/counterparty";

export type CounterpartiesFilters = Pick<
    FiltersTypes,
    "counterpartiesIds" | "withEmptyOrUnverifiedCounterparty"
>;

export const NO_COUNTERPARTY_LABEL = "No vendor/customer";

export type CounterpartiesWithEmptyValue = Array<{
    counterparty: Counterparty | null;
}>;
